import { createContext, type PropsWithChildren, useContext } from 'react';
import type { MyOCData } from '@cx-web/domain-types/myoc';

export type MyOCUserProviderProps = {
  myocData: MyOCData;
};

export type MyOCUserProviderData = {
  myocData: MyOCData;
};

export const MyOCUserContext = createContext<MyOCUserProviderData | null>(null);
MyOCUserContext.displayName = 'MyOCUserContext';

export const MyOCUserProvider = ({ children, myocData, ...props }: PropsWithChildren<MyOCUserProviderProps>) => {
  const value = { myocData };

  return (
    <MyOCUserContext.Provider value={value} {...props}>
      {children}
    </MyOCUserContext.Provider>
  );
};

export const useMyOCUser = () => {
  const context = useContext(MyOCUserContext);
  if (!context) {
    throw new Error('useMyOCUser can only be used inside of MyOCUserProvider');
  }

  return context;
};
